import Vue from "vue";
import * as LogoClinicarx from "@/assets/images/Logo_nova_branca.png";
import AppointmentService from "@/api/Services/Appointment";
import RatingService from "@/api/Services/Rating";

import { Component } from "vue-property-decorator";
import { bus } from "@/main";

const RatingProps = Vue.extend({});

@Component({
  name: "RatingPage",
})
export default class RatingPage extends RatingProps {
  appointment_id: any = this.$route.params.appointmentId;
  env: any = this.$route.params.env;
  rating: any = 0;
  registered: any = false;

  cx_header_logo = LogoClinicarx;

  mounted() {
    setTimeout(() => {
      bus.$emit("showFooter", false);
    }, 500);

    this.getAppointment();
  }

  getAppointment() {
    AppointmentService.getAppointment(this.appointment_id, this.env).then((response: any) => {
      const { clinic_id, id, patient_id, service_id = null } = response.data.data;
      this.setRating(clinic_id, id, patient_id, service_id);
    });
  }

  setRating(clinic_id: string, appointment_id: string, patient_id: string, service_id: string) {
    const data = {
      clinic_id,
      patient_id,
      service_id,
      appointment_id,
      rating: this.$route.params.rating,
      review: "",
      created_at: new Date(),
      env: this.env,
    };

    RatingService.setRating(data)
      .then((response: any) => {
        bus.$emit("showLoading", false);
        if (response.data.message === "Avaliação já realizada") {
          this.registered = true;
          this.rating = response.data.data.rating;
        } else {
          this.rating = this.$route.params.rating;
        }
      })
      .catch((error) => {
        this.$router.push({
          name: "NotFoundPage",
        });
      });
  }
}
